import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    Typography,
    Box,
    CircularProgress,
} from '@mui/material';

import Trend from '../utils/Trend'; // Import the Trend component

type ParticipantProgressPopupProps = {
    detailModalOpen : boolean,
    setDetailModalOpen : (flag:boolean)=> void,
    selectedParticipant : string | null,
    loadingDialog : boolean,
    participantDetails : any[],
    participantTrends : any [],
};


const ParticipantProgressPopup = ({
                            detailModalOpen,
                            setDetailModalOpen,
                            selectedParticipant,
                            loadingDialog,
                            participantDetails,
                            participantTrends,
                        } : ParticipantProgressPopupProps) => {
    // Helper function to extract a sequence of trends for a specific category
    const getTrendSequence = (key:string) => participantTrends.map((trend) => trend[key]);

    return (
        <Dialog open={detailModalOpen} onClose={() => setDetailModalOpen(false)} fullWidth maxWidth="md">
            <DialogTitle>прогресс участника: {selectedParticipant}</DialogTitle>
            <DialogContent>
                {loadingDialog ? (
                        <Box display="flex" justifyContent="center" mt={3}>
                            <CircularProgress/>
                        </Box>
                    )
                    : participantDetails.length == 0 ? (
                            <Typography>Детали не найдены.</Typography>
                        )
                        : (
                            <>
                                <Box mb={3}>
                                    {/*<Typography variant="h6">Тренды участника</Typography>*/}
                                    <Box mt={2}>
                                        <Typography>Прогресс:</Typography>
                                        <Box display="flex" gap={1} mt={1}>
                                            {getTrendSequence('progress_trend').map((trend, index) => (
                                                <Trend key={`progress-${index}`} trend={trend} />
                                            ))}
                                        </Box>
                                        <Typography mt={2}>Активность:</Typography>
                                        <Box display="flex" gap={1} mt={1}>
                                            {getTrendSequence('activity_trend').map((trend, index) => (
                                                <Trend key={`activity-${index}`} trend={trend} />
                                            ))}
                                        </Box>
                                        <Typography mt={2}>Разносторонность:</Typography>
                                        <Box display="flex" gap={1} mt={1}>
                                            {getTrendSequence('versatility_trend').map((trend, index) => (
                                                <Trend key={`versatility-${index}`} trend={trend} />
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Заруба</TableCell>
                                                <TableCell>Прогресс (%)</TableCell>
                                                <TableCell>Записей</TableCell>
                                                <TableCell>Последняя запись</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {participantDetails.map((detail) => (
                                                <TableRow key={detail.contest_id}>
                                                    <TableCell>{detail.contest_name}</TableCell>
                                                    <TableCell>{detail.total_progress?.toFixed(0)}</TableCell>
                                                    <TableCell>{detail.total_entries}</TableCell>
                                                    <TableCell>{new Date(detail.last_activity).toLocaleString()}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        )}
            </DialogContent>
        </Dialog>
    );
};

export default ParticipantProgressPopup;
